module.exports = __webpack_public_path__ + "img/ico-yz1.339e536a.png";